'use strict';

const Debug = require('../util/debug')('airplay');

import * as domUtils from '../util/dom';
import device from '../util/device';
import Sizzle from 'sizzle';

const EVENT_NAMESPACE = 'airplay';

const instances = new Map();

class AirPlay {
    constructor(api) {
        this.api = api;

        this.api.once(EVENT_NAMESPACE + '.ready', () => this._setupEventListeners());
    }

    _setupEventListeners() {
        if (!window.WebKitPlaybackTargetAvailabilityEvent) {
            return;
        }

        Debug('Airplay init');

        if (device.isAirplayCapable()) {
            domUtils.addEvents(this.api.video(), 'webkitplaybacktargetavailabilitychanged', (e) => this._onAvailabilityChange(e), EVENT_NAMESPACE);
        }

        domUtils.addEvents(this.api.video(), 'webkitcurrentplaybacktargetiswirelesschanged', (e) => this._onWirelessChanged(e), EVENT_NAMESPACE);
    }

    _onAvailabilityChange(event) {
        Debug(event, event.availability);

        if (event.availability === 'available') {
            domUtils.show(this._createButton());
        }
    }

    _onWirelessChanged(event) {
        Debug('webkitcurrentplaybacktargetiswireless', this.api.video().webkitCurrentPlaybackTargetIsWireless, event);

        if (this.api.video().webkitCurrentPlaybackTargetIsWireless) {
            this.api.once(EVENT_NAMESPACE + '.canplay', () => this.api.play()); //fixes a bug with airplay stuck in pause state
            this.api.data().allowNoUi = false;
        } else {
            this.api.data().allowNoUi = true;
        }
    }

    _createButton() {
        let button = Sizzle('.svp_airplay-button', this.api.element())[0];
        if (button) {
            return button;
        }

        button = domUtils.fromString('<div class="svp_airplay-button"></div>');

        button.addEventListener('click', (e) => {
            e.stopPropagation();
            this.api.video().webkitShowPlaybackTargetPicker();
        });

        button.addEventListener('touchend', (e) => {
            e.stopPropagation();
            this.api.video().webkitShowPlaybackTargetPicker();
        });

        this.api.insertButton(button);

        return button;
    }

    destroy() {
        if (!window.WebKitPlaybackTargetAvailabilityEvent) {
            return;
        }

        const button = Sizzle('.svp_airplay-button', this.api.element())[0];
        if (button) {
            button.parentElement.removeChild(button);
        }

        if (device.isAirplayCapable()) {
            domUtils.removeEvents(this.api.video(), 'webkitplaybacktargetavailabilitychanged', EVENT_NAMESPACE);
        }
        domUtils.removeEvents(this.api.video(), 'webkitcurrentplaybacktargetiswirelesschanged', EVENT_NAMESPACE);

        this.api.off(EVENT_NAMESPACE + '.ready');
    }
}

export function create(api) {
    instances.set(api, new AirPlay(api));
}

export function destroy(api) {
    const instance = instances.get(api);

    if (instance) {
        instance.destroy();
        instances.delete(api);
    }
}



// WEBPACK FOOTER //
// ./src/js/plugins/airplay.js